import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';

import DropdownView from 'core/views/dropdown';


export default Backbone.View.extend({
  initialize: function (options) {
    _.bindAll(this, 'render', 'domain_filter', 'state_filter', 'prepare_params');

    this.template = _.template($('#coach-filters-tmpl').html());
    this.coachhub = options.coachhub;
    this.domains = this.coachhub.domains;
    this.user = this.coachhub.coachhub_user;
    this.coach_list_view = this.coachhub.coach_list_view;

    this.render();
  },
  render: function () {
    this.$el.html(this.template({ domains: this.domains, user: this.user }));
    $('.check', this.filter).click(this.domain_filter);
    this.states_dropdown = new DropdownView({ el: $('#state-type-dropdown', this.$el) });
    this.states_dropdown.on('selected', this.state_filter);
  },
  domain_filter: function (e) {
    $(e.currentTarget).toggleClass('setting-enabled');
    this.prepare_params();
    return true;
  },
  state_filter: function (e) {
    this.prepare_params();
    return true;
  },
  prepare_params: function () {
    var params = {};
    var domains = _.map($('.setting-enabled', this.el),
      function (e) { return e.getAttribute('data-value'); });
    if (domains.length) {
      params.domains = domains;
    }
    if (this.states_dropdown.selected_item.attr('data-value')) {
      params.region = 'US-' + this.states_dropdown.selected_item.attr('data-value');
    }
    this.coach_list_view.rerender_coaches(params);
  }
});



// WEBPACK FOOTER //
// ./static/js/views/coach_filters.js